import React from 'react';
import { CodeArtifact } from './types';
import { PagesUpdatedCard } from './cards/PagesUpdatedCard';
import { TestResultsCard } from './cards/TestResultsCard';
import { HitlStepCard } from './cards/HitlStepCard';
import { PreviewUrlCard } from './cards/PreviewUrlCard';
interface Props {
  artifact: CodeArtifact;
  breadcrumb?: string;
  onAnswerHitl: (id: string, answer: string) => void;
  onViewInSession?: () => void;
}
export function ArtifactCardRouter({
  artifact,
  breadcrumb,
  onAnswerHitl,
  onViewInSession
}: Props) {
  switch (artifact.kind) {
    case 'pages-updated':
      return <PagesUpdatedCard artifact={artifact} breadcrumb={breadcrumb} onViewInSession={onViewInSession} data-id="element-414" />;
    case 'test-results':
      return <TestResultsCard artifact={artifact} breadcrumb={breadcrumb} onViewInSession={onViewInSession} data-id="element-415" />;
    case 'hitl-step':
      return <HitlStepCard artifact={artifact} breadcrumb={breadcrumb} onAnswer={answer => onAnswerHitl(artifact.id, answer)} onViewInSession={onViewInSession} data-id="element-416" />;
    case 'preview-url':
      return <PreviewUrlCard artifact={artifact} breadcrumb={breadcrumb} onViewInSession={onViewInSession} data-id="element-417" />;
  }
}